const ORDER_STATUS = {
  AguardandoPcSap: 13,
  AguardandoFornecimento: 14,
  AguardandoAprovacaoGestor: 15,
};

const BUYER_GROUP_STATUSES = [
  ORDER_STATUS.AguardandoPcSap,
  ORDER_STATUS.AguardandoAprovacaoGestor,
  ORDER_STATUS.AguardandoFornecimento,
];

const CANCELLATION_ENDPOINT = {
  Padrao: "orders/cancel",
  Direto: "orders/direct-cancel",
};

const requiresDirectCancellation = (order) => BUYER_GROUP_STATUSES.includes(order.OrderStatus);

const buildCancellationRequest = (endpoint, orders, note) => ({
  API: endpoint,
  method: "post",
  body: {
    Orders: orders.map((order) => ({
      OrderId: order.Id,
      OrderType: order.OrderType,
      CancellationJustification: order.TypeJustificationManualSuggestion,
    })),
    Observation: note,
  },
  errorId: orders.map((order) => order.Id).join(", "),
});

export const getRequestsToCancel = (orders, forcedCancel, note) => {

  if (orders.length === 0) {
    return [];
  }

  const usesDirectCancellation = forcedCancel || orders.some(requiresDirectCancellation);
  const endpoint = usesDirectCancellation
    ? CANCELLATION_ENDPOINT.Direto
    : CANCELLATION_ENDPOINT.Padrao;

  return [buildCancellationRequest(endpoint, orders, note)];
};

export const getDataToCancel = (order, forcedCancel, note) =>
  getRequestsToCancel([order], forcedCancel, note)[0];
